











  import { defineComponent, computed, PropType } from 'vue'
  import useCurrentInstance from '~/utils/useCurrentInstance'
  import useAddToCart from '@/composables/useAddToCart'

  interface Product {
    productId: string
    quantity: number
  }
  interface Props {
    products: Array<Product>
  }

  export default defineComponent({
    name: 'OneCmsProductPack',
    props: {
      products: {
        type: Array as PropType<Product[]>,
        default: () => [],
      },
    },
    setup(props: Props) {
      const vm = useCurrentInstance()
      const { addSelectedToCart } = useAddToCart(vm)

      const currentCartId = computed(() => vm.$store.getters['cart/getCurrentCartId'])

      const addProductPackToCart = () => {
        const payload = props.products.map((product) => {
          return { productId: product.productId, amountOfProducts: product.quantity }
        })
        addSelectedToCart(payload, 'product-pack').then(() => vm.$store.dispatch('cart/fetchCurrentCart', { cartId: currentCartId.value }))
      }

      return { addProductPackToCart }
    },
  })
